module.exports = __webpack_public_path__ + "static/img/create-project.74ebf1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/create-project.jpg
// module id = 9eX3
// module chunks = 1